import React from 'react'
import { Box, Container } from 'rebass'

const Wrapper = props => (
  <Box {...props} my={[4, 5, 6]}>
    <Container {...props} />
  </Box>
)

export default Wrapper



// WEBPACK FOOTER //
// ./src/containers/Hero/Wrapper.js